import { CommonContext } from '@repo-level/core-front';
import { StagContext } from 'contexts/stag';
import { Country } from 'helpers/conf';
import { useMedia } from 'modules/common/hooks/useMedia';
import moment from 'moment';
import { useContext } from 'react';
import { localStorageStag } from '../modules/userTrackingParams/hooks/useTrackingUserParams';

const MONDAY = 1;
const FRIDAY = 5;
const START_TIME = 7;
const END_TIME = 19;
const FRANCE_OFFSET = 1;

const STAGS_RESTRICTED_BY_TIME = ['211045', '212432'];

const isWeekdayAndBusinessHoursInFrance = () => {
  const currentDateTimeInFrance = moment().utcOffset(FRANCE_OFFSET);

  const isWeekday =
    currentDateTimeInFrance.isoWeekday() >= MONDAY &&
    currentDateTimeInFrance.isoWeekday() <= FRIDAY;
  const isBusinessHours =
    currentDateTimeInFrance.hours() <= START_TIME ||
    currentDateTimeInFrance.hours() >= END_TIME;

  return !isWeekday || isBusinessHours;
};

export function useFranceLocale() {
  const { isMobile } = useMedia();
  const { currentIp } = useContext(CommonContext);
  const { isStag } = useContext(StagContext);

  const isFrance = currentIp?.countryCode === Country.France;

  const stag = localStorageStag.get();
  const isRestrictedByTimeStag = STAGS_RESTRICTED_BY_TIME.includes(stag || '');

  return {
    isFR: isFrance,
    isRestricted:
      isFrance &&
      !isMobile &&
      !isWeekdayAndBusinessHoursInFrance() &&
      isRestrictedByTimeStag,
    isFRWithStag: isFrance && isStag,
    isFRWithoutStag: isFrance && !isStag,
  };
}
